import {
  SHOPIFY_API_VERSION,
  SHOPIFY_CUSTOM_DOMAIN,
  SHOPIFY_STOREFRONT_ACCESS_TOKEN
} from '@petplate/settings';
import { createStorefrontApiClient, type ClientResponse } from '@shopify/storefront-api-client';

type ResponseErrors = {
  message?: string;
  networkStatusCode?: number;
  graphQLErrors?: object[] | undefined;
};

export const errorToSentryBreadcrumb = (errors?: ResponseErrors) => ({
  message: errors?.message,
  data: {
    statusCode: errors?.networkStatusCode,
    graphqlErrors: errors?.graphQLErrors
  }
});

export const storefrontClient = createStorefrontApiClient({
  storeDomain: `https://${SHOPIFY_CUSTOM_DOMAIN}`,
  apiVersion: SHOPIFY_API_VERSION || '2024-10',
  publicAccessToken: SHOPIFY_STOREFRONT_ACCESS_TOKEN
});

/**
 * Checks if a Shopify Storefront API request failed
 * @param response - The response object from the Shopify Storefront API
 * @returns a boolean indicating if the request failed
 */
export const checkRequestFailed = (response: ClientResponse): boolean => !!response.errors;
